import { render } from "./OrgOptionTile.vue?vue&type=template&id=7e81ad3a"
import script from "./OrgOptionTile.vue?vue&type=script&lang=js"
export * from "./OrgOptionTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__